export default __webpack_public_path__ + "static/media/2_MontajAğırlıkÖrnekExcelData.c377cac0.xlsx";